/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { IconWrapperRounded } from "../../components/IconWrapperRounded";
import { colors } from "../../components/colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { StyledText } from "../../assets/typography/typography";
import { formatMoneyAmount } from "../../util";
import { CircleContainer } from "../../components/CircleContainer";
import { DeliveryRule } from "../../service/api-response/DeliveryRule";
import { DeliveryRulesSelector } from "./delivery-rules-modal/DeliveryRulesSelector";

type Props = {
  group: DeliveryRule;
};

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${colors.ctaInactive};
  justify-content: space-between;
`;

const subWrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

const infoWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const subInfoStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const DeliveryRuleComponent = ({ group }: Props) => {
  return (
    <div css={wrapperStyle}>
      <div css={subWrapperStyle}>
        <IconWrapperRounded
          backgroundColor={colors.ctaLight}
          color={colors.ctaMain}
          width="40px"
          height="40px"
        >
          <FontAwesomeIcon icon={solid("section")} />
        </IconWrapperRounded>
        <div css={infoWrapperStyle}>
          <StyledText
            color={colors.textPrimary}
            className="bodyHeaderTwoSemibold mb-0"
          >
            {group.name}
          </StyledText>
          <div css={subInfoStyle}>
            <StyledText
              color={colors.textPrimary}
              className="bodySubtextRegular mb-0"
            >
              {formatMoneyAmount(
                group.minimumDeliveryPrice.value,
                group.minimumDeliveryPrice.currency
              )}
            </StyledText>
            <CircleContainer
              width="4px"
              height="4px"
              backgroundColor={colors.ctaInactive}
            />
            <StyledText
              color={colors.ctaMain}
              className="bodySubtextSemibold mb-0"
            >
              {group.rules.length} {group.rules.length === 1 ? "rule" : "rules"}
            </StyledText>
          </div>
        </div>
      </div>
      <DeliveryRulesSelector
        groupId={group.id}
        color={colors.textPrimary}
        backgroundColor={colors.transparent}
        hoverColor={colors.ctaLight}
      />
    </div>
  );
};
